<template>
  <div
    class="profileList"
    data-aos="fade-up"
    data-aos-easing="linear"
    data-aos-duration="1500"
  >
    <my-brand :routerlist="routerlist" />
    <p class="profileWallet">
      {{ profileData.address }}
    </p>
    <div class="flex justify-center items-center">
      <p class="profileName">
        {{ profileData.profile_name }}
      </p>
      <img
        class="btnImg"
        src="../../assets/img/changeName.svg"
        alt="changeName"
        @click="openconfirmtDialog"
      >
    </div>
    <div
      v-if="profileData.projects && profileData.projects.length > 0"
      class="profileList-wrapper"
    >
      <div
        v-for="item in profileData.projects"
        :key="item.project_id"
        class="project"
      >
        <h3 class="project-name">
          {{ item.project_name }}
        </h3>
        <div class="project-item">
          <div
            v-for="itemChild in item.all_tokens"
            :key="itemChild"
            class="profileList-item"
          >
            <!-- <p class="profileID"># {{ itemChild }}</p> -->
            <img
              v-lazy="`${$config.normalRequestBaseUrl}/art/${itemChild}/png`"
            >
            <div class="overlay">
              <p class="profileID">
                # {{ itemChild }}
              </p>
              <div class="block-wrapper flex justify-around items-end">
                <div class="leftBtn">
                  <img src="../../assets/img/opensea.svg" alt="logoBtn">
                </div>
                <div class="rigthBtn">
                  <img src="../../assets/img/artblock.png" alt="logoBtn">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="noData-wrapper">
      No Data
    </div>
    <confirmtDialog ref="confirm" />
  </div>
</template>

<script>
import { mapState } from "vuex";
const sigUtil = require("eth-sig-util");
import { fetchGet } from "@/common/utils/request.js";
import { fetchUpdateProfile } from "@/contactLogic/manage";

export default {
  data() {
    return {
      profileData: {},
    };
  },
  computed: {
    ...mapState(["web3", "ethersprovider", "ethChainID", "ethAddress"]),
    routerlist(){
      return [{to:'/',name:'Home'},{to:'/members',name:'Members'},{name:'profile'}];
    }
  },
  methods: {
    async getProfileList() {
      const profileID = this.$route.params.profileID;
      try {
        const res = await fetchGet(`/api/member/profile/${profileID}`, {});
        console.log(res);
        this.profileData = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    openconfirmtDialog() {
      if (this.profileData.address === this.ethAddress) {
        this.$refs.confirm.open(this.profileName);
      } else {
        this.$Notice.error({
          title: "Failed to edit",
          desc: "You can’t edit this",
          duration: 10,
        });
      }
    },
    async onChangeName(newName) {
      const from = this.ethAddress;

      const signObject = {
        address: from,
        update_detail: { profile_name: newName },
      };

      const msg = this.web3.utils.toHex(signObject);
      // var msg = '0x1' // hexEncode(text)
      console.log(msg);

      /*  web3.personal.sign not yet implemented!!!
       *  We're going to have to assemble the tx manually!
       *  This is what it would probably look like, though:
        web3.personal.sign(msg, from) function (err, result) {
          if (err) return console.error(err)
          console.log('PERSONAL SIGNED:' + result)
        })
      */

      console.log("CLICKED, SENDING PERSONAL SIGN REQ");
      const params = [msg, from];

      const method = "personal_sign";
      // const _this = this;
      this.web3.currentProvider.sendAsync(
        { method, params, from },
        async (err, result) => {
          if (err) return console.error(err);
          if (result.error) return console.error(result.error);

          console.log("PERSONAL SIGNED:" + JSON.stringify(result.result));

          const signature = result.result;
          const data = await fetchUpdateProfile({
            ...signObject,
            update_detail_signature: signature,
          });

          console.log(data, 3333);
          if (data.code === 200) {
            this.$Notice.success({
              title: "Successfully modified",
              duration: 10,
            });
            this.getProfileList();
          } else {
            this.$Notice.error({
              title: "Failed to edit",
              desc: data.code,
              duration: 10,
            });
          }

          // console.log("recovering...");
          // const msgParams = { data: msg };
          // msgParams.sig = result.result;
          // console.dir({ msgParams });
          // // console.log(sigUtil);
          // const result1 = await _this.web3.eth.personal.ecRecover(
          //   msgParams.data,
          //   msgParams.sig
          // );
          // console.log(result1);
          // const recovered = sigUtil.recoverPersonalSignature(msgParams);
          // console.dir({ recovered });
          //
          // if (recovered === from.toLocaleLowerCase()) {
          //   console.log("SigUtil Successfully verified signer as " + from);
          //   // window.alert("SigUtil Successfully verified signer as " + from);
          // } else {
          //   console.dir(recovered);
          //   console.log(
          //     "SigUtil Failed to verify signer when comparing " +
          //     recovered.result +
          //     " to " +
          //     from
          //   );
          //   console.log("Failed, comparing %s to %s", recovered, from);
          // }
        }
      );
    },
  },
  components: {
    confirmtDialog: () => import("./dialog/confirmDialog.vue"),
  },
  created() {
    this.getProfileList();
  },
};
</script>

<style lang="less" scoped>
.profileWallet,
.profileName {
  color: #ccc;
  font-size: 24px;
}
.profileWallet {
  width: 100%;
  text-align: center;
  padding: 20px 0;
}
.btnImg {
  max-width: 24px;
  margin-left: 12px;
  cursor: pointer;
}
.profileList-wrapper {
  width: 100%;
  .project-name {
    font-size: 20px;
    color: #fff;
    text-align: center;
    margin: 30px 0px;
  }
  .project-item {
    display: grid;
    margin-top: 30px;
  }

  .profileList-item {
    position: relative;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    .profileID {
      position: absolute;
      color: #fff;
      font-size: 16px;
      left: 10px;
      top: 10px;
      // margin: 10px 0 20px;
    }
    img {
      width: 100%;
      border-radius: 10px;
      object-fit: contain;
      vertical-align: middle;
    }
    .overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      opacity: 0;
      transition: 0.2s ease;
      .block-wrapper {
        width: 100%;
        height: 100%;
        padding: 20px 0;
        .leftBtn {
          cursor: pointer;
          width: 20%;
        }
        .rigthBtn {
          cursor: pointer;
          width: 20%;
        }
      }
    }

    &:hover {
      .overlay {
        opacity: 0.8;
        transition: ease 0.5s;
        background-color: #000000;
        cursor: zoom-in;
        border-radius: 10px;
      }
    }
  }
}

@media (min-width: 1201px) {
  .project-item {
    grid-template-columns: 23.5% 23.5% 23.5% 23.5%;
    grid-row-gap: 20px;
    grid-column-gap: 2%;
  }
}

@media (max-width: 1200px) {
  .project-item {
    grid-template-columns: 48% 48%;
    grid-row-gap: 20px;
    grid-column-gap: 4%;
  }
}
</style>
